// src/schemas/fieldSchemas.ts
import { z } from 'zod';

export const phoneFieldRequired = z
  .string()
  .min(1, 'Phone number is required')
  .regex(
    /^\(\d{3}\) \d{3}-\d{4}$/,
    'Phone number must be in format (123) 456-7890'
  );

export const emailFieldRequired = z
  .string()
  .email('Please enter a valid email address');

export const stringFieldRequired = (fieldName: string) =>
  z.string().min(1, `${fieldName} is required`);

export const fileUploadField = ({
  fieldName = 'File',
  maxSizeMB = 5,
  acceptedTypes = ['image/jpeg', 'image/png'],
}: {
  fieldName?: string;
  maxSizeMB?: number;
  acceptedTypes?: string[];
} = {}) =>
  z
    .any()
    .optional()
    .refine(
      (file) => !file || file instanceof File,
      `${fieldName} must be a valid file`
    )
    .refine(
      (file) => !file || file.size <= maxSizeMB * 1024 * 1024,
      `${fieldName} must be smaller than ${maxSizeMB}MB`
    )
    .refine(
      (file) => !file || acceptedTypes.includes(file.type),
      `Invalid file type. ${fieldName} must be one of these: ${acceptedTypes.join(', ')}`
    );
